module.exports = __webpack_public_path__ + "img/origins.24cd2205.png";